import { Injectable } from '@angular/core';
import { ResourceService } from '../resource/resource.service';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import {HttpService, PaginatedResponse} from '../http-service/http.service';
import {Observable} from 'rxjs';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export abstract class ResourceContentService<T extends ResourceModel> extends ResourceService<T> {
    protected constructor(protected override httpService: HttpService<T>) {
        super(httpService);
    }

    getContent(path = ''): Observable<ResourceModel[]> {
        return super.getList(`${path}/.list`);
    }

    getContainers(path: string): Observable<ResourceModel[]> {
        return super.getList(`${path}/.containers`);
    }

    getListPage(pageSize: number, filter?: string, sort?: string, ascending?: boolean, continueToken?: string): Observable<PaginatedResponse<T[]>> {
        let queryParams = [];

        if (filter) {
            queryParams.push(`filter=${filter}`);
        }
        if (pageSize) {
            queryParams.push(`pageSize=${pageSize}`);
        }
        if (sort) {
            queryParams.push(`sort=${sort}`);
        }
        if (ascending !== undefined) {
            queryParams.push(`ascending=${ascending}`);
        }
        if (continueToken) {
            queryParams.push(`continueToken=${continueToken}`);
        }
        const queryString = queryParams.join('&');

        return this.httpService.getPaginatedList<T[]>(`${this.APIUrl}?${queryString}`);
    }
}
